// extracted by mini-css-extract-plugin
export default {"Emojify":"bcb_a bic_g"};